/**
 * @ngdoc component
 * @name common.component:ItxShopCartPackagingError
 *
 * @param {object} shopCart Default values
 *
 * @description
 * Modal with packaging options.
 *
 */
(function () {
    'use strict';

    var ItxShopCartPackagingErrorCmp = {
        bindings: {
            shopCart: '<'
        },
        controller: ItxShopCartPackagingErrorCmpCtrl,
        templateUrl: 'shop-cart-packaging-error.component.html'
    };

    ItxShopCartPackagingErrorCmpCtrl.$inject = ['ngDialog'];

    function ItxShopCartPackagingErrorCmpCtrl(ngDialog) {
        var _this = this;
        _this.itemsError = [];
        _this.$onInit = function () {
            // variable que indica que el articulo viene de sint
            let isSint = '2';
            _this.shopCart.items.forEach((item) => {
                if (item.stockLocations && item.stockLocations[0].stockLocationId === isSint) {
                    _this.itemsError.push(item);
                }
            });
        };

        _this.close = function () {
            ngDialog.close();
        };
    }

    angular.module('itxApp.common').component('itxShopCartPackagingError', ItxShopCartPackagingErrorCmp);
})();
